export default {
  // Tab names
  'tab.main': 'หลัก',
  'tab.producers': 'ผู้ผลิต',
  'tab.achievements': 'ความสำเร็จ',
  'tab.prestige': 'เกิดใหม่',
  'tab.settings': 'ตั้งค่า',

  // Header
  'header.bps': '/วิ',
  'header.stage': 'ขั้น',
  'header.tap': 'TAP!',

  // Combo
  'combo.nice': 'Nice!',
  'combo.great': 'Great!',
  'combo.amazing': 'Amazing!',
  'combo.incredible': 'INCREDIBLE!',
  'combo.legendary': 'LEGENDARY!',
  'combo.label': 'คอมโบ',

  // Critical
  'crit.label': 'CRITICAL!',

  // Producers
  'producer.P1': 'เมล็ดพันธุ์',
  'producer.P2': 'หน่อ',
  'producer.P3': 'กล้า',
  'producer.P4': 'ต้นกาแฟ',
  'producer.P5': 'ไร่เล็ก',
  'producer.P6': 'ไร่ใหญ่',
  'producer.P7': 'โรงคั่ว',
  'producer.P8': 'โรงงานกาแฟ',
  'producer.P9': 'ศูนย์ส่งออก',
  'producer.P10': 'แฟรนไชส์',
  'producer.P11': 'จักรวรรดิกาแฟ',
  'producer.P12': 'ดาวกาแฟ',

  // Tap upgrades
  'upgrade.T1': 'นิ้วไว',
  'upgrade.T2': 'ถุงมือ',
  'upgrade.T3': 'เครื่องมือ',
  'upgrade.T4': 'เครื่องจักร',
  'upgrade.T5': 'หุ่นยนต์',
  'upgrade.T6': 'นาโนเทค',
  'upgrade.T7': 'เก็บเกี่ยวควอนตัม',
  'upgrade.T8': 'บิดเบือนเวลา',

  // Prestige upgrades
  'prestige.G1': 'เมล็ดทอง',
  'prestige.G1.desc': 'BPS +1 พื้นฐาน',
  'prestige.G2': 'ดินอุดม',
  'prestige.G2.desc': 'พลังแตะ x1.5',
  'prestige.G3': 'ส่วนลดมือใหม่',
  'prestige.G3.desc': 'P1~P3 ค่าใช้จ่าย -50%',
  'prestige.G4': 'เติบโตข้ามคืน',
  'prestige.G4.desc': 'ประสิทธิภาพออฟไลน์ +20%',
  'prestige.G5': 'ปลูกเร่งด่วน',
  'prestige.G5.desc': 'BPS รวม x2',
  'prestige.G6': 'มือโชคดี',
  'prestige.G6.desc': 'โอกาสคริติคอล +3%',
  'prestige.G7': 'บาริสต้าระดับเทพ',
  'prestige.G7.desc': 'พลังแตะ x3',
  'prestige.G8': 'ส่วนลดขายส่ง',
  'prestige.G8.desc': 'ค่าใช้จ่ายทั้งหมด -20%',
  'prestige.G9': 'เริ่มต้นเร็ว',
  'prestige.G9.desc': 'เริ่มด้วย P1~P3 อย่างละ 10',
  'prestige.G10': 'เบลนด์พรีเมียม',
  'prestige.G10.desc': 'BPS รวม x3',
  'prestige.G11': 'เมล็ดแห่งกาลเวลา',
  'prestige.G11.desc': 'ประสิทธิภาพออฟไลน์ 100%',
  'prestige.G12': 'มงกุฎราชากาแฟ',
  'prestige.G12.desc': 'การผลิตรวม x2',
  'prestige.G13': 'ต้นเมล็ดทอง',
  'prestige.G13.desc': 'ได้รับเมล็ดทอง +20%',
  'prestige.G14': 'ย้อนเวลา',
  'prestige.G14.desc': 'เริ่มที่ขั้น 5',
  'prestige.G15': 'เมล็ดอนันต์',
  'prestige.G15.desc': 'การผลิตรวม x10',
  'prestige.G16': 'บิ๊กแบงกาแฟ',
  'prestige.G16.desc': 'ได้รับเมล็ดทอง x2',

  // Star upgrades
  'star.S1': 'ทุนเริ่มต้น',
  'star.S1.desc': '1 ล้านเมล็ดเมื่อเริ่ม',
  'star.S2': 'ทองนิรันดร์',
  'star.S2.desc': 'เมล็ดทอง x2 ถาวร',
  'star.S3': 'พรแห่งดวงดาว',
  'star.S3.desc': 'BPS รวม x5 ถาวร',
  'star.S4': 'แตะอัตโนมัติ',
  'star.S4.desc': 'แตะอัตโนมัติ 1 ครั้ง/วิ',
  'star.S5': 'จ้าวคอมโบ',
  'star.S5.desc': 'คอมโบคงอยู่ 3 วินาที',
  'star.S6': 'โจมตีร้ายแรง',
  'star.S6.desc': 'ตัวคูณคริติคอล x2',
  'star.S7': 'พลังจักรวาล',
  'star.S7.desc': 'การผลิตรวม x10 ถาวร',
  'star.S8': 'ดาวแห่งการหลุดพ้น',
  'star.S8.desc': 'โบนัสขึ้นสู่ดวงดาว x3',

  // Varieties
  'variety.V1': 'อาราบิก้า',
  'variety.V2': 'โรบัสต้า',
  'variety.V3': 'ลิเบอริก้า',
  'variety.V4': 'เอ็กเซลซ่า',
  'variety.V5': 'เกอิชา',
  'variety.V6': 'โกปิ ลูวัก',
  'variety.V7': 'บลู เมาน์เทน',
  'variety.V8': 'โคน่า',
  'variety.V9': 'เยอร์กาเชฟ',
  'variety.V10': 'พีเบอร์รี่',
  'variety.V11': 'มาราโกจิเป',
  'variety.V12': 'เซนต์ เฮเลนา',

  // Stages
  'stage.1': 'สวนของคุณยาย',
  'stage.2': 'ลานเล็กๆ',
  'stage.3': 'ไร่กาแฟ',
  'stage.4': 'โรงคั่ว',
  'stage.5': 'โรงงานกาแฟ',
  'stage.6': 'เครือข่ายโลก',
  'stage.7': 'อาณาจักรกาแฟ',

  // Roasting
  'roast.perfect': 'คั่วสมบูรณ์แบบ!',
  'roast.dark': 'คั่วเข้ม',
  'roast.medium': 'คั่วกลาง',
  'roast.light': 'คั่วอ่อน',
  'roast.burnt': 'ไหม้แล้ว...',
  'roast.raw': 'ยังดิบ',
  'roast.tap': 'แตะเพื่อหยุด!',
  'roast.reward': 'รางวัล',
  'roast.double': 'ดูโฆษณารับ 2 เท่า!',
  'roast.collect': 'รับ',

  // Achievements
  'ach.tap1': 'ก้าวแรก', 'ach.tap1.desc': 'แตะ 100 ครั้ง',
  'ach.tap2': 'มือขยัน', 'ach.tap2.desc': 'แตะ 1,000 ครั้ง',
  'ach.tap3': 'จ้าวแตะ', 'ach.tap3.desc': 'แตะ 10,000 ครั้ง',
  'ach.tap4': 'นิ้วตำนาน', 'ach.tap4.desc': 'แตะ 100,000 ครั้ง',
  'ach.tap5': 'เทพแห่งการแตะ', 'ach.tap5.desc': 'แตะ 1,000,000 ครั้ง',
  'ach.tap6': 'มือไว', 'ach.tap6.desc': 'แตะ 5 ครั้ง/วินาที',
  'ach.tap7': 'มือสายฟ้า', 'ach.tap7.desc': 'แตะ 10 ครั้ง/วินาที',
  'ach.tap8': 'มือเทพ', 'ach.tap8.desc': 'แตะ 15 ครั้ง/วินาที',
  'ach.tap9': 'คลั่งคอมโบ', 'ach.tap9.desc': 'ทำ 20 คอมโบ',
  'ach.tap10': 'คอมโบตำนาน', 'ach.tap10.desc': 'ทำ 50 คอมโบ',

  'ach.prod1': 'เก็บเกี่ยวแรก', 'ach.prod1.desc': 'เก็บเกี่ยวรวม 1 พันเมล็ด',
  'ach.prod2': 'ความสำเร็จเล็กๆ', 'ach.prod2.desc': 'เก็บเกี่ยวรวม 1 แสนเมล็ด',
  'ach.prod3': 'ไร่กำลังโต', 'ach.prod3.desc': 'เก็บเกี่ยวรวม 10 ล้านเมล็ด',
  'ach.prod4': 'เจ้าพ่อกาแฟ', 'ach.prod4.desc': 'เก็บเกี่ยวรวม 1 พันล้านเมล็ด',
  'ach.prod5': 'จักรพรรดิกาแฟ', 'ach.prod5.desc': 'เก็บเกี่ยวรวม 1 ล้านล้านเมล็ด',
  'ach.prod6': 'เริ่มอัตโนมัติ', 'ach.prod6.desc': 'ถึง BPS 100',
  'ach.prod7': 'โรงงานทำงาน', 'ach.prod7.desc': 'ถึง BPS 1 หมื่น',
  'ach.prod8': 'ปฏิวัติอุตสาหกรรม', 'ach.prod8.desc': 'ถึง BPS 1 ล้าน',
  'ach.prod9': 'ผลิตระดับโลก', 'ach.prod9.desc': 'ถึง BPS 100 ล้าน',
  'ach.prod10': 'ผลิตระดับจักรวาล', 'ach.prod10.desc': 'ถึง BPS 1 หมื่นล้าน',

  'ach.bld1': 'ชาวไร่มือใหม่', 'ach.bld1.desc': 'มี P1~P4 อย่างละ 1',
  'ach.bld2': 'ชาวไร่ระดับกลาง', 'ach.bld2.desc': 'มี P1~P8 อย่างละ 1',
  'ach.bld3': 'ชาวไร่ระดับเทพ', 'ach.bld3.desc': 'มีผู้ผลิตทุกชนิด',
  'ach.bld4': 'ลงทุนเน้นๆ', 'ach.bld4.desc': 'มีชนิดเดียว 10 ตัว',
  'ach.bld5': 'ซื้อเหมา', 'ach.bld5.desc': 'มีชนิดเดียว 25 ตัว',
  'ach.bld6': 'นักสะสม', 'ach.bld6.desc': 'มีชนิดเดียว 50 ตัว',
  'ach.bld7': 'ราชาผูกขาด', 'ach.bld7.desc': 'มีชนิดเดียว 100 ตัว',
  'ach.bld8': 'ขยายกิจการ', 'ach.bld8.desc': 'ผู้ผลิตรวม 100 ตัว',
  'ach.bld9': 'จักรวรรดิธุรกิจ', 'ach.bld9.desc': 'ผู้ผลิตรวม 500 ตัว',
  'ach.bld10': 'ครองโลก', 'ach.bld10.desc': 'ผู้ผลิตรวม 1,000 ตัว',

  'ach.pres1': 'เกิดใหม่ครั้งแรก', 'ach.pres1.desc': 'เกิดใหม่ 1 ครั้ง',
  'ach.pres2': 'รสชาติของการทำซ้ำ', 'ach.pres2.desc': 'เกิดใหม่ 3 ครั้ง',
  'ach.pres3': 'จ้าวเกิดใหม่', 'ach.pres3.desc': 'เกิดใหม่ 5 ครั้ง',
  'ach.pres4': 'วงจรไม่สิ้นสุด', 'ach.pres4.desc': 'เกิดใหม่ 10 ครั้ง',
  'ach.pres5': 'วงแหวนนิรันดร์', 'ach.pres5.desc': 'เกิดใหม่ 20 ครั้ง',
  'ach.pres6': 'เซียนวัฏสงสาร', 'ach.pres6.desc': 'เกิดใหม่ 50 ครั้ง',
  'ach.pres7': 'เก็บเกี่ยวทอง', 'ach.pres7.desc': 'ได้ 10 เมล็ดทองในครั้งเดียว',
  'ach.pres8': 'พายุทอง', 'ach.pres8.desc': 'ได้ 100 เมล็ดทองในครั้งเดียว',
  'ach.pres9': 'สปีดรันเนอร์', 'ach.pres9.desc': 'เกิดใหม่ภายใน 30 นาที',
  'ach.pres10': 'เกิดใหม่สายฟ้า', 'ach.pres10.desc': 'เกิดใหม่ภายใน 15 นาที',

  'ach.spec1': 'นักล่าเชอร์รี่', 'ach.spec1.desc': 'แตะเชอร์รี่ทอง 1 ครั้ง',
  'ach.spec2': 'คลั่งเชอร์รี่', 'ach.spec2.desc': 'แตะเชอร์รี่ทอง 10 ครั้ง',
  'ach.spec3': 'จ้าวเชอร์รี่', 'ach.spec3.desc': 'แตะเชอร์รี่ทอง 50 ครั้ง',
  'ach.spec4': 'หัดคั่ว', 'ach.spec4.desc': 'คั่วสมบูรณ์แบบ 1 ครั้ง',
  'ach.spec5': 'เซียนคั่ว', 'ach.spec5.desc': 'คั่วสมบูรณ์แบบ 10 ครั้ง',
  'ach.spec6': 'นักสะสมพันธุ์', 'ach.spec6.desc': 'สะสม 5 สายพันธุ์',
  'ach.spec7': 'ด็อกเตอร์กาแฟ', 'ach.spec7.desc': 'สะสมครบ 12 สายพันธุ์',
  'ach.spec8': 'ชาวไร่ขยัน', 'ach.spec8.desc': 'เล่นรวม 1 ชั่วโมง',
  'ach.spec9': 'ติดกาแฟ', 'ach.spec9.desc': 'เล่นรวม 24 ชั่วโมง',
  'ach.spec10': '7 วันต่อเนื่อง', 'ach.spec10.desc': 'เข้าสู่ระบบ 7 วันติดต่อกัน',

  'ach.mile1': 'เจ้าของไร่กาแฟ', 'ach.mile1.desc': 'ถึงขั้น 3',
  'ach.mile2': 'นักธุรกิจกาแฟ', 'ach.mile2.desc': 'ถึงขั้น 5',
  'ach.mile3': 'ราชากาแฟ', 'ach.mile3.desc': 'ถึงขั้น 7',
  'ach.mile4': 'ผู้หลุดพ้น', 'ach.mile4.desc': 'ขึ้นสู่ดวงดาวครั้งแรก',
  'ach.mile5': 'นักสมบูรณ์แบบ', 'ach.mile5.desc': 'ปลดล็อก 50 ความสำเร็จ',

  // Achievement categories
  'ach.cat.tapping': 'แตะ',
  'ach.cat.production': 'การผลิต',
  'ach.cat.producers': 'ผู้ผลิต',
  'ach.cat.prestige': 'เกิดใหม่',
  'ach.cat.special': 'พิเศษ',
  'ach.cat.milestone': 'เหตุการณ์สำคัญ',

  // Prestige panel
  'prestige.title': 'เกิดใหม่จากการคั่ว',
  'prestige.desc': 'เกิดใหม่เพื่อรับเมล็ดทองแล้วเริ่มใหม่แข็งแกร่งกว่าเดิม!',
  'prestige.goldenBeans': 'เมล็ดทอง',
  'prestige.expected': 'คาดว่าจะได้',
  'prestige.rebirth': 'เกิดใหม่',
  'prestige.upgrades': 'อัปเกรดเกิดใหม่',
  'prestige.locked': 'ปลดล็อกเมื่อถึงขั้น 7',
  'prestige.adBonus': 'ดูโฆษณา +30%',

  // Ascension panel
  'ascend.title': 'ขึ้นสู่ดวงดาว',
  'ascend.desc': 'ขึ้นสู่ดวงดาวเพื่อรับฝุ่นดาวแล้วก้าวข้ามทุกสิ่ง!',
  'ascend.starDust': 'ฝุ่นดาว',
  'ascend.expected': 'คาดว่าจะได้',
  'ascend.ascend': 'ขึ้นสู่ดวงดาว',
  'ascend.upgrades': 'อัปเกรดดาว',
  'ascend.locked': 'ต้องเกิดใหม่ 10 ครั้ง + เมล็ดทอง 100',

  // Settings
  'settings.bgm': 'เพลงพื้นหลัง',
  'settings.sfx': 'เอฟเฟกต์เสียง',
  'settings.vibration': 'สั่น',
  'settings.language': 'ภาษา',
  'settings.reset': 'รีเซ็ตข้อมูล',
  'settings.resetConfirm': 'คุณแน่ใจหรือว่าต้องการลบข้อมูลทั้งหมด?',
  'settings.credits': 'เครดิต',
  'settings.version': 'เวอร์ชัน',

  // Boost buttons
  'boost.tap': 'บูสต์แตะ',
  'boost.bps': 'บูสต์การผลิต',

  // Offline
  'offline.title': 'ยินดีต้อนรับกลับ!',
  'offline.earned': 'รายได้ออฟไลน์',
  'offline.time': 'เวลาที่จากไป',
  'offline.collect': 'รับ',
  'offline.adX3': 'ดูโฆษณารับ x3',

  // General
  'buy': 'ซื้อ',
  'max': 'สูงสุด',
  'level': 'Lv.',
  'locked': 'ล็อก',
  'owned': 'มี',
  'on': 'เปิด',
  'off': 'ปิด',
} as const;
